/**
 * @generated SignedSource<<a0818933f9e4f421f6fb001fd10162d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFurtherReadingWidgetArticle$data = {
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
  } | null | undefined> | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentType": "articleFurtherReadingWidgetArticle";
};
export type articleFurtherReadingWidgetArticle$key = {
  readonly " $data"?: articleFurtherReadingWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFurtherReadingWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFurtherReadingWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleWidgetContent"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "1d588f101a1a1724d820763eff2f35d5";

export default node;
